<template>
  <div
    class="signup-progress"
    :aria-label="ariaLabel"
  >
    <div class="lm-row">
      <component
        v-for="item in items"
        :is="item.tag"
        :key="item.key"
        :class="item.class"
      >
        <div
          v-if="item.tag === 'div'"
          class="lm-line-fill"
        ></div>
        <template v-else>{{ item.n }}</template>
      </component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressDots',
  props: {
    total: { type: Number, required: true },
    current: { type: Number, required: true },
    ariaLabel: { type: String, required: true },
  },
  computed: {
    // Flatten the dots-and-connecting-lines into a single keyed list so the
    // template can render with one v-for. Avoids <template v-for> entirely
    // (lint rules disagree across Vue 2 / 3 about where the key belongs).
    items() {
      const out = [];
      for (let n = 1; n <= this.total; n++) {
        out.push({
          tag: 'span',
          key: 'lm-' + n,
          n,
          class: ['lm', { done: n < this.current, current: n === this.current }],
        });
        if (n < this.total) {
          out.push({
            tag: 'div',
            key: 'line-' + n,
            class: ['lm-line', { done: n < this.current }],
          });
        }
      }
      return out;
    },
  },
};
</script>
